import { Phone } from "lucide-react";
import { SHOP, waLink, formatPrice, productMessage, imgSrc } from "@/lib/shop";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const ProductCard = ({ product: p }) => {
  const price = formatPrice(p.price);
  return (
    <article className="group bg-white rounded-2xl border border-slate-200 p-3 flex flex-col h-full hover:shadow-xl hover:border-brand-200 hover:-translate-y-1 transition-[box-shadow,border-color,transform] duration-300" data-testid={`product-card-${p._id}`}>
      <div className="relative aspect-square rounded-xl overflow-hidden bg-slate-100">
        {p.image_url ? <img src={imgSrc(p.image_url)} alt={p.name} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="h-full w-full grid place-items-center font-display text-2xl font-black text-slate-300">FONZ FIX4U</div>}
        <span className={`absolute top-3 left-3 rounded-full px-3 py-1 text-xs font-bold ${p.condition === "New" ? "bg-brand-600 text-white" : "bg-white text-slate-900"}`}>{p.condition}</span>
        {!p.in_stock && <span className="absolute top-3 right-3 rounded-full bg-ink px-3 py-1 text-xs font-bold text-white">Sold out</span>}
      </div>
      <div className="px-2 pt-4 pb-2 flex flex-col flex-1">
        <h3 className="font-display text-lg font-bold text-ink leading-tight">{p.name}</h3>
        <p className="mt-1 text-sm text-slate-500">{[p.storage, p.colour].filter(Boolean).join(" · ") || "\u00A0"}</p>
        {p.description && <p className="mt-2 text-sm text-slate-600 line-clamp-2">{p.description}</p>}
        <div className="mt-4 flex items-end justify-between">
          <p className="font-display text-2xl font-black text-ink" data-testid={`product-price-${p._id}`}>
            {price || <span className="text-base font-bold text-brand-600">Ask for price</span>}
          </p>
        </div>
        <div className="mt-4 grid grid-cols-[1fr_auto] gap-2 whitespace-nowrap">
          <a href={waLink(productMessage(p))} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-3 py-3 text-[13px] font-bold text-white hover:bg-[#20BD5A] transition-colors" data-testid={`product-whatsapp-btn-${p._id}`}>
            <WhatsAppIcon className="h-4 w-4" /> Enquire on WhatsApp
          </a>
          <a href={`tel:${SHOP.phoneTel}`} aria-label={`Call about ${p.name}`} className="inline-flex items-center justify-center rounded-full border-2 border-slate-200 px-4 text-slate-800 hover:border-brand-600 hover:text-brand-600 transition-colors" data-testid={`product-call-btn-${p._id}`}>
            <Phone className="h-4 w-4" />
          </a>
        </div>
      </div>
    </article>
  );
};
